import { Navbar } from "./Navbar";
import { ScoreMarquee } from "./ScoreMarquee";
import { Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getMeta } from "../lib/api";
import { Toaster } from "./ui/sonner";
import { SeasonPicker } from "./SeasonPicker";

export const Layout = () => {
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: getMeta });
  const isLive = meta?.source === "api-sports";
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <Toaster position="top-right" theme="dark" />
      <Navbar />
      <ScoreMarquee />
      <main className="mx-auto max-w-[1400px] px-4 sm:px-6 py-8 fade-up">
        <div data-testid="season-bar" className="flex items-center justify-end gap-3 mb-6">
          <span className="label-caps hidden sm:inline">Viewing</span>
          <SeasonPicker />
        </div>
        <Outlet />
      </main>
      <footer className="border-t-2 border-border mt-16">
        <div className="mx-auto max-w-[1400px] px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-6 bg-primary" />
            <span className="font-display text-2xl">GRIDIRON</span>
          </div>
          <p data-testid="data-source-note" className="text-xs text-muted-foreground max-w-md">
            {isLive
              ? `Live NFL data: ${meta.gamesSeason} schedule & scores, ${meta.statsSeason} stats & standings. Powered by API-SPORTS.`
              : "Loading live NFL data… showing sample data until the feed syncs."}
          </p>
        </div>
      </footer>
    </div>
  );
};
